"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _utils = _interopRequireDefault(require("../utils/utils"));

var _Pagination = _interopRequireDefault(require("./Pagination.style"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _dec, _class;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const DOTS = '...';
let Pagination = (_dec = (0, _reactJss.default)(_Pagination.default), _dec(_class = class Pagination extends _react.PureComponent {
  correctSize(size) {
    return Number(size) || 0;
  }

  correctLimit(limit) {
    return Number(limit) || 1;
  }

  correctValue(value, paginationSize) {
    let corValue = Number(value);
    if (!corValue) return 0;

    if (corValue < 1) {
      corValue = 1;
    } else if (corValue > paginationSize) {
      corValue = paginationSize;
    }

    return corValue;
  } // Замена {range}, {size} в label


  replaceLabelVars(value, size, limit, label) {
    let replacedLabel = _utils.default.stripHtml(label); // Дипазон отображаемых элеметов


    if (replacedLabel.includes('{range}')) {
      const rangeStart = (value - 1) * limit + 1;
      const rangeEnd = value * limit < size ? value * limit : size; // выделяем range semibold

      const range = `<span class="range">${rangeStart}-${rangeEnd}</span>`;
      replacedLabel = replacedLabel.replace('{range}', range);
    } // Общее количество элементов


    if (replacedLabel.includes('{size}')) {
      replacedLabel = replacedLabel.replace('{size}', size);
    }

    return replacedLabel;
  } // Обработчик клика на элементе или иконках


  handleClick(itemValue, value) {
    const {
      id,
      onChange,
      visibility
    } = this.props;

    if (visibility === 'disabled' || itemValue === value || itemValue === DOTS) {
      return;
    }

    const error = false;
    onChange({
      id,
      value: itemValue,
      error
    });
  } // Создаем элемент пагинации


  getPageElement(itemValue, value) {
    const {
      classes
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: _utils.default.random(),
      className: (0, _clsx.default)(classes.item, {
        active: itemValue === value
      }, {
        disabled: itemValue === DOTS
      }),
      onClick: () => this.handleClick(itemValue, value)
    }, itemValue);
  } // Формируем элементы пагинации и рендерим


  renderPagination(value, paginationSize) {
    const pagination = [];
    if (!value || !paginationSize) return pagination;
    const maxPagesShown = 9;
    let items;

    if (paginationSize <= maxPagesShown) {
      items = _utils.default.range(1, paginationSize);
    } else {
      const startSubSet = [1];
      const endSubSet = [paginationSize];
      const startLimit = value + 1 <= paginationSize ? value - 2 : paginationSize - 2;
      const endLimit = value - 1 > 0 ? value + 2 : 3;

      const mainSubSet = _utils.default.range(startLimit, endLimit).filter(i => i > 0 && i <= paginationSize);

      items = [...new Set([...startSubSet, ...mainSubSet, ...endSubSet])];
    }

    let prevPage = 0;
    items.forEach(page => {
      if (page - 1 !== prevPage) {
        pagination.push(this.getPageElement(DOTS, value));
      }

      pagination.push(this.getPageElement(page, value));
      prevPage = page;
    });
    return pagination;
  }

  render() {
    const {
      classes,
      className,
      id,
      visibility,
      value,
      size,
      limit,
      label
    } = this.props;
    const corSize = this.correctSize(size);
    const corLimit = this.correctLimit(limit);
    const paginationSize = Math.ceil(corSize / corLimit); // Количество элеметов пагинации

    const corValue = this.correctValue(value, paginationSize);
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(className, classes.container, {
        hidden: visibility === 'hidden'
      }, {
        disabled: visibility === 'disabled'
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.label,
      dangerouslySetInnerHTML: {
        __html: this.replaceLabelVars(corValue, corSize, corLimit, label)
      }
    }), paginationSize > 1 ? /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.pagination, {
        hidden: corSize === 0 || corValue === 0
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.iconContainer, classes.iconPrev)
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.icon, {
        hidden: corValue === 1
      }),
      type: "dropdown",
      size: "micro",
      color: "currentColor",
      onClick: () => this.handleClick(corValue - 1, corValue)
    })), this.renderPagination(corValue, paginationSize), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.iconContainer, classes.iconNext)
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.icon, {
        hidden: corValue === paginationSize
      }),
      type: "dropdown",
      size: "micro",
      color: "currentColor",
      onClick: () => this.handleClick(corValue + 1, corValue)
    }))) : null);
  }

}) || _class);
Pagination.defaultProps = {
  visibility: 'visible',
  value: '1',
  onChange: () => {},
  label: '{range} / {size}'
};
var _default = Pagination;
exports.default = _default;